import React, { useState } from 'react';
import axios from 'axios';
import kycImage from './kyc1.png';
import logo from './c_logo.png'; // Import the logo

const VerifyOtp = ({ email, setStep }) => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [otpFocused, setOtpFocused] = useState(false);

  const handleVerifyOtp = async () => {
    if (!otp.match(/^\d{6}$/)) {
      alert('Enter a valid 6-digit OTP');
      return;
    }

    setLoading(true);
    try {
      await axios.post('https://backend-22l3.onrender.com/api/emails/verify-otp', { email, otp });
      alert('OTP Verified Successfully');
      setStep(3);
    } catch (err) {
      alert('Invalid OTP');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const toggleOtpVisibility = () => {
    setShowOtp(!showOtp);
  };

  return (
    <div style={styles.mainContainer}>
      <div style={styles.headerContainer}>
        <div style={styles.headerTitle}>Coin Street - Online KYC Portal</div>
        <img src={logo} alt="Company Logo" style={styles.logo} />
      </div>
      
      <div style={styles.contentContainer}>
        <div style={styles.formSection}>
          <h2 style={styles.verifyTitle}>Verify OTP</h2>
          <p style={styles.otpSentText}>OTP sent to {email}</p>
          
          <div style={styles.inputGroup}>
            <div style={styles.floatingLabelContainer}>
              <label 
                style={{
                  ...styles.floatingLabel,
                  ...((otpFocused || otp) && styles.floatingLabelFocused),
                  ...(otpFocused && { color: '#0033a0' })
                }}
              >
                Enter OTP
              </label>
              <div style={styles.inputWithIcon}>
                <input
                  type={showOtp ? "text" : "password"}
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  onFocus={() => setOtpFocused(true)}
                  onBlur={() => setOtpFocused(false)}
                  style={{
                    ...styles.textInput,
                    ...(otpFocused && styles.inputFocused)
                  }}
                  maxLength="6"
                  required
                />
                <button 
                  type="button" 
                  onClick={toggleOtpVisibility} 
                  style={styles.visibilityToggle}
                >
                  {showOtp ? (
                    /* Eye open icon */
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                  ) : (
                    /* Eye closed icon */
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                      <line x1="1" y1="1" x2="23" y2="23"></line>
                    </svg>
                  )}
                </button>
              </div>
            </div>
          </div>
          
          <div style={styles.buttonGroup}>
            <button 
              onClick={handleVerifyOtp} 
              disabled={loading} 
              style={styles.verifyButton}
            >
              {loading ? 'Verifying...' : 'Verify OTP'}
            </button>
            
            <button 
              onClick={() => setStep(1)} 
              style={styles.backButton}
            >
              Back
            </button>
          </div>
        </div>
        
        <div style={styles.illustrationSection}>
          <img src={kycImage} alt="KYC Illustration" style={styles.kycIllustration} />
        </div>
      </div>
      
      <div style={styles.footer}>
        <div style={styles.footerText}>SEBI RIA: INA000001382</div>
        <div style={styles.footerText}>www.coinstreet.in</div>
        <div style={styles.footerText}>support@coinstreet.in</div>
      </div>
    </div>
  );
};

const styles = {
  mainContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    margin: 0,
    fontFamily: 'Poppins, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    overflow: 'hidden',
    justifyContent: 'space-between'
  },
  headerContainer: {
    flex: '0 0 54px', // Decreased from 60px by 10%
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 18px', // Decreased from 20px by 10%
    backgroundColor: '#fff',
    boxShadow: '0 1.8px 4.5px rgba(0, 0, 0, 0.1)', // Decreased from 2px and 5px by 10%
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    width: '100%',
    boxSizing: 'border-box'
  },
  headerTitle: {
    fontSize: 'calc(12.6px + 0.72vw)', // Decreased from 14px and 0.8vw by 10%
    fontWeight: 'bold',
    color: '#0033a0',
    '@media (max-width: 768px)': {
      fontSize: '14.4px' // Decreased from 16px by 10%
    }
  },
  logo: {
    height: '72px', // Decreased from 80px by 10%
    objectFit: 'contain',
    '@media (max-width: 768px)': {
      height: '54px' // Decreased from 60px by 10%
    }
  },
  contentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '18px', // Decreased from 20px by 10%
    paddingLeft: '9%', // Decreased from 10% by 10%
    width: '100%',
    boxSizing: 'border-box',
    overflow: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 992px)': {
      flexDirection: 'column-reverse',
      padding: '9px', // Decreased from 10px by 10%
      paddingLeft: '4.5%' // Decreased from 5% by 10%
    }
  },
  formSection: {
    flex: '0 0 40%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '13.5px', // Decreased from 15px by 10%
    padding: '0 18px', // Decreased from 20px by 10%
    maxWidth: '450px', // Decreased from 500px by 10%
    width: '100%',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 992px)': {
      flex: '1 0 auto',
      maxWidth: '100%',
      margin: '0',
      padding: '18px 9px' // Decreased from 20px and 10px by 10%
    }
  },
  verifyTitle: {
    fontSize: '21.6px', // Decreased from 24px by 10%
    fontWeight: 'bold',
    color: '#0033a0',
    marginBottom: '9px', // Decreased from 10px by 10%
    '@media (max-width: 768px)': {
      fontSize: '18px', // Decreased from 20px by 10%
      marginBottom: '4.5px' // Decreased from 5px by 10%
    }
  },
  otpSentText: {
    fontSize: '12.6px', // Decreased from 14px by 10%
    color: '#666',
    marginBottom: '9px' // Decreased from 10px by 10%
  },
  inputGroup: {
    width: '100%',
    marginBottom: '18px', // Decreased from 20px by 10%
    '@media (max-width: 768px)': {
      marginBottom: '13.5px' // Decreased from 15px by 10%
    }
  },
  floatingLabelContainer: {
    position: 'relative',
    width: '100%'
  },
  floatingLabel: {
    position: 'absolute',
    left: 10.8, // Decreased from 12px by 10%
    top: 10.8, // Decreased from 12px by 10%
    color: '#999',
    fontSize: '12.6px', // Decreased from 14px by 10%
    pointerEvents: 'none',
    transition: 'all 0.2s ease',
    backgroundColor: 'transparent',
    padding: '0 3.6px', // Decreased from 4px by 10%
    zIndex: 1
  },
  floatingLabelFocused: {
    top: -7.2, // Decreased from -8px by 10%
    left: 7.2, // Decreased from 8px by 10%
    fontSize: '10.8px', // Decreased from 12px by 10%
    backgroundColor: '#fff',
    padding: '0 3.6px' // Decreased from 4px by 10%
  },
  inputWithIcon: {
    position: 'relative',
    width: '100%'
  },
  textInput: {
    width: '100%',
    padding: '10.8px', // Decreased from 12px by 10%
    borderRadius: '3.6px', // Decreased from 4px by 10%
    border: '0.9px solid #ccc', // Decreased from 1px by 10%
    fontSize: '12.6px', // Decreased from 14px by 10%
    boxSizing: 'border-box',
    marginBottom: '13.5px', // Decreased from 15px by 10%
    outline: 'none',
    transition: 'all 0.3s ease',
    paddingRight: '36px' // Decreased from 40px by 10%
  },
  inputFocused: {
    border: '1.8px solid #0033a0', // Decreased from 2px by 10%
    boxShadow: '0 0 0 1.8px rgba(0, 51, 160, 0.2)' // Decreased from 2px by 10%
  },
  visibilityToggle: {
    position: 'absolute',
    right: '9px', // Decreased from 10px by 10%
    top: '50%',
    transform: 'translateY(-65%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#666',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0
  },
  buttonGroup: {
    display: 'flex',
    gap: '13.5px', // Decreased from 15px by 10%
    marginTop: '9px', // Decreased from 10px by 10%
    justifyContent: 'left'
  },
  verifyButton: {
    padding: '9px 18px', // Decreased from 10px and 20px by 10%
    backgroundColor: '#0033a0',
    color: 'white',
    border: 'none',
    borderRadius: '3.6px', // Decreased from 4px by 10%
    cursor: 'pointer',
    fontWeight: 'bold',
    width: '135px', // Decreased from 150px by 10%
    fontSize: '12.6px', // Decreased from 14px by 10%
    transition: 'background-color 0.3s',
    ':hover': {
      backgroundColor: '#002080'
    }
  },
  backButton: {
    padding: '9px 18px', // Decreased from 10px and 20px by 10%
    backgroundColor: '#6c757d',
    color: 'white',
    border: 'none',
    borderRadius: '3.6px', // Decreased from 4px by 10%
    cursor: 'pointer',
    fontWeight: 'bold',
    width: '135px', // Decreased from 150px by 10%
    fontSize: '12.6px', // Decreased from 14px by 10%
    transition: 'background-color 0.3s',
    ':hover': {
      backgroundColor: '#5a6268'
    }
  },
  illustrationSection: {
    flex: '0 0 55%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 992px)': {
      flex: '0 0 auto',
      width: '100%',
      maxHeight: '27vh', // Decreased from 30vh by 10%
      margin: '0 0 9px 0', // Decreased from 10px by 10%
      transform: 'none'
    }
  },
  kycIllustration: {
    maxWidth: '100%',
    maxHeight: '81%', // Decreased from 90% by 10%
    objectFit: 'contain',
    '@media (max-width: 992px)': {
      maxHeight: '90%' // Decreased from 100% by 10%
    }
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '13.5px 9px', // Decreased from 15px and 10px by 10%
    backgroundColor: '#fff',
    flexWrap: 'wrap',
    flexShrink: 0,
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      gap: '4.5px', // Decreased from 5px by 10%
      padding: '9px' // Decreased from 10px by 10%
    }
  },
  footerText: {
    flex: '1 0 auto',
    textAlign: 'center',
    fontSize: '19.8px', // Decreased from 22px by 10%
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 400,
    color: '#012C9C',
    margin: '0 18px', // Decreased from 20px by 10%
    '@media (max-width: 768px)': {
      fontSize: '10.8px', // Decreased from 12px by 10%
      margin: '1.8px 0' // Decreased from 2px by 10%
    }
  }
};

export default VerifyOtp;